export default function(string) {
  // TODO: add tests for this
  return (string && string.length > 0)
}
